import React, { Component } from 'react'
import Axios from 'axios';
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import TopBar from '../topbar/topbar'
import search from '../assets/search.png'
import { BASE } from '../api/api';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser'
import './faculty.css'
import { List } from 'react-content-loader';

import ReactPaginate from 'react-paginate';

// import 'bootstrap/dist/css/bootstrap.min.css';


const url = 'http://ifdb-be.tridz.in/'

const completed_data = [
    { lead: ["Fintech, Digital Currency", " (Palgrave Macmillan)"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle" },
]
const publication_data = [
    { lead: ["Fintech, Digital Currency", " (Palgrave Macmillan)"], title: 'Alam, Nafis & Ali, Syed Nazim', grant: "Book Chapter", year: "2020" },
    { lead: ["Morocco Chapter on Shariah", "Governance in Islamic Finance"], title: 'Aassouli, Dalal', grant: "Book", year: "2020" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
    { lead: ["Dr. Ibrahim Zain", "Dr. Ibrahim Zain"], title: 'Covenants of the prophet Covenants of the prophet Covenants of the prophet', grant: "3rd Cycle", year: "2013" },
]

const members_data = [
    { img: "/clusters/ifdbPerson.jpg", name: "Dr. Syed Nazim Ali", desg: "Director" },
    { img: "/clusters/ifdbPerson.jpg", name: "Saqid Hafiz Khateeb", desg: "IBIR-Project Lead" },
    { img: "/clusters/ifdbPerson.jpg", name: "Umar Farooq patel", desg: "Research Fellow" },
    { img: "/clusters/ifdbPerson.jpg", name: "Bahnaz Ali Al-Quradaghi", desg: "Researcher" },
    { img: "/clusters/ifdbPerson.jpg", name: "Zul hakim bin Jumat", desg: "Researcher" },
]

const books_data = [
    { title: "Bringing Islamic finance to the people", year: "2021", },
    { title: "Transforming Qatar into A Circular Economy: Challenges and Opportunities and the Role of Islamic Finance", year: "2021", },
    { title: "Islamic finance by UK institutions", year: "2021", },
    { title: "Bringing Islamic finance to the people", year: "2021", },
    { title: "Transforming Qatar into A Circular Economy: Challenges and Opportunities and the Role of Islamic Finance", year: "2021", },
    { title: "Islamic finance by UK institutions", year: "2021", },
    { title: "Bringing Islamic finance to the people", year: "2021", },
    { title: "Transforming Qatar into A Circular Economy: Challenges and Opportunities and the Role of Islamic Finance", year: "2021", },
    { title: "Islamic finance by UK institutions", year: "2021", },
    { title: "Bringing Islamic finance to the people", year: "2021", },

]
const cycle_data1 = [
    { title: "Hinduism in Muslim Theology", lead: "Dr. Dheen Muhamed", grant: "QAR 20,000" },
    { title: "Islamic Sukuk", lead: "Dr. Abdelrahman", grant: "QAR 20,000" },
    { title: "Islamic Sukuk", lead: "Dr. Abdelrahman", grant: "QAR 20,000" }
]

class CisFaculty extends Component {

    constructor(props) {
        super(props);
        this.state = {
            size: 10,
            tab: 1,
        }
    }

    render() {
        return (
            <div>
                <Header />
                <div className='container'>
                    <div className='subHeader'>
                        <div className='top-contents'>
                            <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/research/'>Research</Link> / <Link to='/research/'>Projects</Link></div>
                            <TopBar data={'data4'} />
                        </div>
                    </div>
                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="">
                                <h1 className="heading">CIS Faculty</h1>
                            </div>
                        </div>
                    </div>
                    <div className='cisFaculty-sub justify-content-between'>
                        <div className='cisFaculty-profile'>
                            <img src="/clusters/ifdbPerson.jpg" className='cisFaculty-profileImage' />
                            <div className='cisFaculty-stats'>
                                <div>
                                    <div>Citation Statistics</div>
                                    <div>(h-index)</div>
                                </div>
                                <p>13</p>
                            </div>
                        </div>
                        <div className='cisFaculty-profileContainer'>
                            <div className='d-flex  justify-content-between align-items-center '>
                                <p className='cisFaculty-name heading'>Ahmet Faruk Aysan</p>
                                <a className='publications-btn'><p>Add Publications</p></a>
                            </div>
                            <p>Associate Professor of <a>Islamic Finance</a></p>
                            <a>College of Islamic Studies</a>
                            <p>Ahmet Faruk Aysan received his B.A. in economics from the Bogaziçi University (1999) and his M.A. (2001) and his Ph.D. (2005) in economics from the University of Maryland College Park. He was Lecturer at Department of Economics at Bogaziçi University since 2005, and then Associate Professor at Istanbul Sehir University in 2008. He has served as a consultant at various institutions such as the World Bank, the Central Bank of the Republic of Turkey. Apart from his duties at Bogaziçi University, he was also a member of the G-20 Financial Safety Net Experts Group, a member of the Advisory Board of Social Sciences and Humanities Research Group of TÜBİTAK, and a National Expert in 'Socio-Economic Sciences and Humanities' under the Seventh Framework Programme of the European Union.</p>
                        </div>
                    </div>


                    <div className='projectall_container'>

                        {
                            <div className='projectsToggle'>
                                <div className="toggle-bars">
                                    <button style={{ backgroundColor: this.state.tab === 1 ? '#165E84' : '', color: this.state.tab === 1 ? "#fff" : "" }} onClick={() => this.setState({ tab: 1 })}>Books</button>
                                    <button style={{ backgroundColor: this.state.tab === 2 ? '#165E84' : '', color: this.state.tab === 2 ? "#fff" : "", marginTop: 0.5 + "rem" }} onClick={() => this.setState({ tab: 2 })}>Book Chapters</button>
                                    <button style={{ backgroundColor: this.state.tab === 3 ? '#165E84' : '', color: this.state.tab === 3 ? "#fff" : "", marginTop: 0.5 + "rem" }} onClick={() => this.setState({ tab: 3 })}>Articles</button>
                                    <button style={{ backgroundColor: this.state.tab === 4 ? '#165E84' : '', color: this.state.tab === 4 ? "#fff" : "", marginTop: 0.5 + "rem" }} onClick={() => this.setState({ tab: 4 })}>Working Papers</button>
                                    <button style={{ backgroundColor: this.state.tab === 5 ? '#165E84' : '', color: this.state.tab === 5 ? "#fff" : "", marginTop: 0.5 + "rem" }} onClick={() => this.setState({ tab: 5 })}>Projects</button>
                                    <button style={{ backgroundColor: this.state.tab === 6 ? '#165E84' : '', color: this.state.tab === 6 ? "#fff" : "", marginTop: 0.5 + "rem" }} onClick={() => this.setState({ tab: 6 })}>conference Papers</button>
                                    <button style={{ backgroundColor: this.state.tab === 7 ? '#165E84' : '', color: this.state.tab === 7 ? "#fff" : "", marginTop: 0.5 + "rem" }} onClick={() => this.setState({ tab: 7 })}>Videos/Podcast</button>
                                </div>
                            </div>
                        }
                        <div className='cisFaculty_table' >

                            <table>
                                {
                                    <tr className='cisFaculty-head'>
                                        <th className='tableHead_1'><p>Title</p></th>
                                        <th className='tableHead_2'><p>Year</p></th>
                                    </tr>

                                }

                                <tbody className=''>

                                    {
                                        this.state.tab === 1 ?
                                            books_data.map((item) => {
                                                return (
                                                    <tr className='projectDetails-row'>
                                                        <td className='grantsCycle_title' >{item.title}</td>
                                                        <td className='grantsCycle_lead'>{item.year}</td>
                                                    </tr>
                                                )
                                            }) :
                                            this.state.tab === 2 ?
                                                books_data.map((item) => {
                                                    return (
                                                        <tr className='projectDetails-row'>
                                                            <td className='grantsCycle_title'>{item.title}</td>
                                                            <td className='grantsCycle_lead'>{item.year}</td>
                                                        </tr>
                                                    )
                                                }) :
                                                this.state.tab === 3 ?
                                                    cycle_data1.map((item) => {
                                                        return (
                                                            <tr className='projectDetails-row'>
                                                                <td className='grantsCycle_title'>{item.title}</td>
                                                                <td className='grantsCycle_lead'>{item.year}</td>
                                                            </tr>
                                                        )
                                                    }) :
                                                    this.state.tab === 4 ?
                                                        books_data.map((item) => {
                                                            return (
                                                                <tr className='projectDetails-row'>
                                                                    <td className='grantsCycle_title'>{item.title}</td>
                                                                    <td className='grantsCycle_lead'>{item.year}</td>
                                                                </tr>
                                                            )
                                                        }) : ""

                                    }
                                </tbody>
                            </table>
                            {/*pagination*/}
                            <ReactPaginate
                                nextLabel=">"
                                // onPageChange={handlePageClick}
                                // onClick={(e) => setNext(setoffseta(state.offseta + 15))}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                                pageCount={100}
                                previousLabel="<"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                containerClassName="pagination"
                                activeClassName="active"
                                activeLinkClassName="activePage"
                                renderOnZeroPageCount={null}
                            />

                        </div>
                    </div>




                </div>
                <Footer />
            </div >
        )
    }
}
export default CisFaculty;